import { useState } from "react";
import Frame from "../Frames/Basic";
import { Stack, Typography, TextField, Alert, Button, Link as A } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Send } from "@mui/icons-material";
import API from "../../services/API";
import { Link } from "react-router-dom";
import { txt } from "../../services/translation"

export default function ForgotPassword(){

    const [email, setEmail] = useState('')
    const [status, setStatus] = useState('ready')
    const statusIs = s => s === status

    const handleSubmit = e => {
        e.preventDefault()

        setStatus('loading')

        API.post('/forgot-password', {email})
            .then(r => setStatus('success'))
            .catch(e => setStatus('error'))
    }

    const sx = {
        maxWidth: 600,
        margin: 'auto'
    }

    return (
        <Frame center>
            {!statusIs('success') && <form onSubmit={handleSubmit}>
                <Stack spacing={3} sx={sx}>
                    <Typography variant='h2'>{txt('forgotPasswordTitle')}</Typography>
    
                    <Typography variant='p'>{txt('resetPasswordInstruction')}</Typography>
    
                    <Typography variant='p'>{txt('resetPasswordEmailSent')}</Typography>
    
                    <TextField
                        label={txt('accountEmailAddress')}
                        name='email'
                        type='email'
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                        size='small'
                        error={statusIs('error')}
                        helperText={statusIs('error') && txt('noAccountForEmailError')}
                    />
    
                    <Stack direction='row' justifyContent='space-between'>
                        <Link to='/login'>
                            <Button variant='outlined'>{txt('cancel')}</Button>
                        </Link>
    
                        <LoadingButton
                            type='submit'
                            variant='contained'
                            endIcon={<Send/>}
                            loading={statusIs('loading')}
                        >
                            {txt('send')}
                        </LoadingButton>
                    </Stack>
                </Stack>
            </form>}
    
            {statusIs('success') && <Stack spacing={3}>
                <Typography variant='h1'>{txt('emailSentTitle')}</Typography>
    
                <Alert severity='success'>
                    {txt('resetPasswordSuccessMessage')}
                </Alert>
    
                <Typography variant='p'>{txt('checkSpamReminder')}</Typography>
    
                <Typography variant='p'>
                    {txt('stillNoEmailMessage')} 
                    <A href="tel:+33554547771">{txt('contactPhoneNumber')}</A>
                </Typography>
            </Stack>}
        </Frame>
    );
    
}